// extracted by mini-css-extract-plugin
module.exports = {"container":"TotalSampleSize_container__2G4m_","input":"TotalSampleSize_input__1oLm9"};